lmApp.
  directive('lmDatepicker2', ['$compile', '$templateCache', 'KeyService',
    function ($compile, $templateCache, KeyService) {
      return {
        restrict: 'E',
        replace: false,
        scope: {
          ngModel: '=',
          placeholder: '@',
          icon: '@',
          ngDisabled: '=?'
        },
        link: function (scope, element, attrs) {
          scope._data_element_ = element;

          var watcher = scope.$watch('ngModel', function (newValue, oldValue) {
            scope.selectedMoment = _RemoveTime(newValue ? (moment.isMoment(newValue) ? newValue : (moment.utc(newValue * 1000))) : moment.utc());
          });

          /**
           * [EVENT HANDLER] Keyboard action
           * @param event
           * @private
           */
          var _OnKeyDown = function (event) {
            var key = event.which;

            if (key === KeyService.Keys.ESCAPE) {
              if (event.preventDefault) event.preventDefault();
              if (event.stopPropagation) event.stopPropagation();

              _ClosePicker();
              return;
            }
          };

          /**
           * Set 00:00:00 for day
           * @param date
           * @returns {moment}
           * @private
           */
          var _RemoveTime = function (date) {
            return date.startOf('day');
          };

          /**
           * Build month from data.
           * @param start - from what date start building
           * @param month - for what month
           * @private
           */
          var _BuildMonth = function (start, month) {
            var weeks = [];
            var done = false;
            var date = start.clone();
            var monthIndex = date.month();
            var count = 0;
            while (!done) {
              weeks.push({days: _BuildWeek(date.clone(), month)});
              date.add(1, "w");
              done = count++ > 2 && monthIndex !== date.month();
              monthIndex = date.month();
            }
            scope.weeks = weeks;
          };

          /**
           * Build week for month
           * @param date - from what date start building
           * @param month - need to check is day from current month or not
           * @returns {Array.<Object>}
           * @private
           */
          var _BuildWeek = function (date, month) {
            var days = [];
            for (var i = 0; i < 7; i++) {
              days.push({
                name: date.format("dd").substring(0, 1),
                number: date.date(),
                isCurrentMonth: date.month() === month.month(),
                isToday: date.isSame(new Date(), "day"),
                date: date
              });
              date = date.clone();
              date.add(1, "d");
            }
            return days;
          };

          /**
           * [DOM] Open data picker: get template, compile, append DOM
           * @private
           */
          var _OpenPicker = function () {
            if (scope.ngDisabled) return;

            angular.element('body').bind('keydown', _OnKeyDown);

            scope._picker_ = $templateCache.get('lm-datepicker/lm-datapicker.tpl.html');
            scope._picker_ = $compile(scope._picker_)(scope);

            scope._picker_.appendTo('body');
            scope.selectedMoment = _RemoveTime(scope.ngModel ? moment.utc(scope.ngModel) : moment.utc());

            scope.selectedYear = scope.selectedMoment.format('YYYY');
            scope.selectedMonth = scope.selectedMoment.format('MMMM');
            scope.selectedDate = scope.selectedMoment.format('D');
            scope.selectedDay = scope.selectedMoment.format('dddd');

            scope._empty_ = scope._picker_.find('#empty.empty_date');

            scope.removeOne = scope.$watch('selectedYear', function (newVal, oldVal) {
              if (newVal !== oldVal) {
                scope.selectYear(newVal);
              }
            });

            scope.removeTwo = scope.$watch('selectedMonth', function (newVal, oldVal) {
              if (newVal !== oldVal) {
                scope.selectMonth(newVal);
              }
            });

            scope.selects = {
              years: [],
              months: []
            };

            var count = moment.utc().format("YYYY");
            count = moment.utc().year(parseInt(--count, 10)).format("YYYY");
            var countTo = parseInt(moment.utc().format("YYYY"), 10) + 6;
            while (count < countTo)  scope.selects.years.push(moment.utc().year(count++).format("YYYY"));

            var count = 0;
            while (count < 12) scope.selects.months.push(moment.utc().month(count++).format("MMMM"));

            var start = scope.selectedMoment.clone();
            start.date(1);
            _RemoveTime(start.day(0));

            _BuildMonth(start, scope.selectedMoment);

/*            TweenMax.from(scope._picker_, 0.35, {
              opacity: '0',
              ease: Expo.easeInOut
            });*/

            scope._empty_.bind('click', _ClosePicker);
          };

          /**
           * [DOM] Close Data Picker: remove from DOM
           * @private
           */
          var _ClosePicker = function () {
            angular.element('body').unbind('keydown', _OnKeyDown);
            scope._empty_.unbind('click', _ClosePicker);

            scope.removeOne();
            scope.removeTwo();

            scope._picker_.remove();
            scope._empty_.remove();

/*            TweenMax.to(scope._picker_, 0.45, {
              opacity: '0',
              ease: Expo.easeInOut,
              onComplete: function () {

              }
            });*/
          };

          /**
           * |---------- BIND EVENTS ----------|
           */
          scope._data_element_.bind('click', _OpenPicker);

          /**
           * [NG-CLICK] Select date
           * @param date
           */
          scope.selectDate = function (date) {
            scope.selectedMoment.date(date.number);
            scope.selectedDate = scope.selectedMoment.format('D');
            scope.selectedDay = scope.selectedMoment.format('dddd');
          };

          /**
           * [NG-CLICK] Select next MONTH
           */
          scope.next = function () {
            var start = scope.selectedMoment.clone();
            start.month(start.month() + 1);
            if (start.month() < scope.selectedMoment.month()) {
              scope.selectedYear = start.year();
              scope.selectedMoment.year(scope.selectedYear);
              scope.selectedYear = scope.selectedMoment.format('YYYY');
            }
            scope.selectedMonth = start.format('MMMM');
          };

          /**
           * [NG-CLICK] Select prev MONTH
           */
          scope.previous = function () {
            var start = scope.selectedMoment.clone();
            start.month(start.month() - 1);
            if (start.month() > scope.selectedMoment.month()) {
              scope.selectedYear = start.year();
              scope.selectedMoment.year(scope.selectedYear);
              scope.selectedYear = scope.selectedMoment.format('YYYY');
            }
            scope.selectedMonth = start.format('MMMM');
          };

          /**
           * [NG-IF] Check selected MONTH
           * @param month
           * @returns {boolean}
           */
          scope.isSelectedMonth = function (month) {
            return month === scope.selectedMonth;
          };

          /**
           * [NG-WATCH] Rebuild if month changed from DOM.select
           * @param month
           */
          scope.selectMonth = function (month) {
            var start = scope.selectedMoment.clone();
            start.month(month);
            start.date(1);
            _RemoveTime(start.day(0));
            scope.selectedMoment.month(month);
            scope.selectedDate = scope.selectedMoment.format('D');
            scope.selectedDay = scope.selectedMoment.format('dddd');
            _BuildMonth(start, scope.selectedMoment);
          };

          /**
           * [NG-IF] Check selected YAER
           * @param year
           * @returns {boolean}
           */
          scope.isSelectedYear = function (year) {
            return year === scope.selectedYear;
          };

          /**
           * [NG-WATCH] Rebuild if year changed from DOM.select
           * @param year
           */
          scope.selectYear = function (year) {
            var start = scope.selectedMoment.clone();
            start.year(year);
            start.date(1);
            _RemoveTime(start.day(0));
            scope.selectedMoment.year(year);
            scope.selectedDate = scope.selectedMoment.format('D');
            scope.selectedDay = scope.selectedMoment.format('dddd');
            _BuildMonth(start, scope.selectedMoment);
          };

          /**
           * [NG-CLICK] Cancel Action
           */
          scope.cancel = function () {
            _ClosePicker();
          };

          /**
           * [NG-CLICK] Set today date
           */
          scope.today = function () {
            scope.selectedMoment = moment.utc().startOf('day');
            scope.selectedMonth = scope.selectedMoment.format('MMMM');
            scope.selectedYear = scope.selectedMoment.format('YYYY');
            scope.selectedDate = scope.selectedMoment.format('D');
            scope.selectedDay = scope.selectedMoment.format('dddd');
          };

          /**
           * [NG-CLICK] Done Action
           */
          scope.done = function () {
            scope.ngModel = scope.selectedMoment.clone();
            _ClosePicker();
          };

          /**
           * Clear scope on $DESTROY
           */
          scope._data_element_.on('$destroy', function () {
            scope._data_element_.unbind('click');
            scope.$destroy();
            if (watcher) watcher();
            if (scope.removeOne) scope.removeOne();
            if (scope.removeTwo) scope.removeTwo();
          })
        },
        templateUrl: 'lm-datepicker/lm-datapicker-input.tpl.html'
      };
    }]);
